var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "question",
      class: {
        authentication: _vm.question.attestationState == 1,
        verification: _vm.question.isVerification
      }
    },
    [
      _c("div", { staticClass: "head" }, [
        _c("div", { staticClass: "small-title" }, [
          _vm.question.year
            ? _c("span", { staticClass: "has-dot" }, [
                _vm._v(_vm._s(_vm._f("date")(_vm.question.year, "yyyy")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.question.address
            ? _c("span", { staticClass: "has-dot" }, [
                _vm._v(_vm._s(_vm.question.address))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.question.sourceTypeName
            ? _c("span", { staticClass: "has-dot" }, [
                _vm._v(_vm._s(_vm.question.sourceTypeName))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.question.source
            ? _c(
                "span",
                {
                  staticClass: "link ml-5",
                  on: {
                    click: function($event) {
                      return _vm.turnPage("source", _vm.question.source)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.question.source))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.question.importRemark && _vm.showInfo
            ? _c("span", { staticClass: "has-dot" }, [
                _vm._v(_vm._s(_vm.question.importRemark))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "title" },
          [
            _vm.index
              ? _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.index) + "、")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showType
              ? _c(
                  "el-tag",
                  {
                    attrs: {
                      effect: "dark",
                      "disable-transitions": "",
                      size: "mini"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("questionType")(
                          _vm.question.questionType,
                          _vm.question.questionTypeTag
                        )
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "content-html",
              staticStyle: { "padding-top": "1px" },
              domProps: { innerHTML: _vm._s(_vm.question.content) }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "edit" },
          [
            _vm.editable
              ? [
                  _vm.question.isVerification
                    ? _c(
                        "el-tag",
                        {
                          attrs: {
                            type: "success",
                            size: "mini",
                            "disable-transitions": ""
                          }
                        },
                        [_vm._v("已检查")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "icon el-icon-edit-outline",
                    attrs: { title: "编辑" },
                    on: { click: _vm.edited }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "icon el-icon-delete",
                    attrs: { title: "删除" },
                    on: { click: _vm.deleted }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("edit")
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.question.questionOptionViewModels.length > 0
        ? _c(
            "ul",
            { staticClass: "options" },
            _vm._l(_vm.question.questionOptionViewModels, function(
              item,
              index
            ) {
              return _c(
                "li",
                { key: index, class: { "is-right": item.isRight } },
                [
                  _vm.question.questionType == 4
                    ? _c("span", {
                        staticClass: "order-sort mr-5",
                        domProps: { innerHTML: _vm._s(item.orderSort) }
                      })
                    : _c("span", { staticClass: "order" }, [
                        _vm._v(_vm._s(_vm.getEN(index)) + "、")
                      ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "content-html",
                    domProps: { innerHTML: _vm._s(item.optionContent) }
                  })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.question.questionType != 6
        ? _c("div", { staticClass: "items answer" }, [
            _c("span", { staticClass: "items-label" }, [_vm._v("参考答案：")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "answer-content content-html",
                class: ["type" + _vm.question.questionType]
              },
              [
                _vm.question.questionType == 1 || _vm.question.questionType == 2
                  ? _vm._l(_vm.question.answer, function(item, index) {
                      return _c("span", {
                        key: index,
                        domProps: { innerHTML: _vm._s(item) }
                      })
                    })
                  : _vm.question.questionType == 3
                  ? _vm._l(_vm.question.answer, function(item, index) {
                      return _c("span", { key: index }, [
                        item + "" == "true"
                          ? _c("span", { staticClass: "font-16" }, [
                              _c("i", {
                                staticClass: "iconfont icon-ic_accepted"
                              })
                            ])
                          : item + "" == "false"
                          ? _c("span", { staticClass: "font-16" }, [
                              _c("i", { staticClass: "iconfont icon-cuowu" })
                            ])
                          : _c("span", [_vm._v(_vm._s(item))])
                      ])
                    })
                  : _vm.question.questionType == 4
                  ? _vm._l(_vm.question.answer, function(item, index) {
                      return _c("span", {
                        key: index,
                        staticClass: "order-sort",
                        domProps: { innerHTML: _vm._s(item) }
                      })
                    })
                  : _vm._l(
                      _vm.question.questionObjectiveAnswerViewModels,
                      function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "fx-box fx-wrap mr-10" },
                          [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(item.answerContent)
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(item.similarityAnswers, function(sItem) {
                              return _c("div", {
                                key: sItem.id,
                                staticClass: "fx-box",
                                domProps: {
                                  innerHTML: _vm._s(" / " + sItem.answerContent)
                                }
                              })
                            })
                          ],
                          2
                        )
                      }
                    )
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question.knowledgePointViewModels.length > 0
        ? _c("div", { staticClass: "items" }, [
            _c("span", { staticClass: "items-label" }, [_vm._v("知识点：")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items-content" },
              [
                _vm._l(_vm.question.knowledgePointViewModels, function(
                  item,
                  index
                ) {
                  return _c(
                    "span",
                    {
                      key: index,
                      staticStyle: {
                        display: "inline-block",
                        "margin-top": "0px"
                      },
                      on: {
                        click: function($event) {
                          return _vm.turnPage("knowledge", item)
                        }
                      }
                    },
                    [
                      _c("el-link", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      index < _vm.question.knowledgePointViewModels.length - 1
                        ? _c("span", [_vm._v("；")])
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm.question.knowledgePointViewModels &&
                _vm.question.knowledgePointViewModels.length == 0
                  ? _c("span", { staticStyle: { color: "#999" } }, [
                      _vm._v("未设置")
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question.questionType != 6 &&
      (_vm.platform == "ms" || _vm.question.variant)
        ? _c("div", { staticClass: "items" }, [
            _c("span", { staticClass: "items-label" }, [_vm._v("问题类型：")]),
            _vm._v(" "),
            _c("div", { staticClass: "items-content" }, [
              _vm.question.variant
                ? _c("span", [_vm._v(_vm._s(_vm.question.variant))])
                : _vm._e(),
              _vm._v(" "),
              !_vm.question.variant && _vm.platform == "ms"
                ? _c("span", { staticStyle: { color: "#999" } }, [
                    _vm._v("未设置")
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.question.questionType == 6 && _vm.showChildren
        ? _c(
            "div",
            {
              staticClass: "question-child",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "el-collapse",
                [
                  _c(
                    "el-collapse-item",
                    [
                      _c("template", { slot: "title" }, [
                        _c(
                          "p",
                          { staticClass: "font-weight font-15 color-333" },
                          [
                            _vm._v("共有子级题目"),
                            _c(
                              "span",
                              {
                                staticClass: "color-primary",
                                staticStyle: { margin: "0 2px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.question.childrenQuestionCount)
                                )
                              ]
                            ),
                            _vm._v("题")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.question.childrenQuestion, function(
                        data,
                        index
                      ) {
                        return _c("single-question", {
                          key: index,
                          attrs: {
                            data: data,
                            index: index + 1,
                            "is-edit": _vm.childEditable,
                            showInfo: _vm.showInfo,
                            showAnalysis: _vm.showAnalysis,
                            showType: _vm.showType
                          },
                          on: { callback: _vm.childrenCallBack }
                        })
                      }),
                      _vm._v(" "),
                      _vm.childEditable &&
                      (_vm.type == "system" || _vm.type == "chapter")
                        ? _c(
                            "div",
                            { staticClass: "mt-10 mb-15" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                    size: "mini"
                                  },
                                  on: { click: _vm.addChildren }
                                },
                                [_vm._v("添加题目")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c(
          "div",
          { staticClass: "info-head" },
          [
            _c(
              "span",
              [
                _vm._v("难度：\n        "),
                _c("el-rate", {
                  staticStyle: { display: "inline" },
                  attrs: {
                    colors: ["#f56c6c", "#f56c6c", "#f56c6c"],
                    disabled: "",
                    "disabled-void-color": "#ccc"
                  },
                  model: {
                    value: _vm.question.difficulty,
                    callback: function($$v) {
                      _vm.$set(_vm.question, "difficulty", $$v)
                    },
                    expression: "question.difficulty"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.question.subjectCatalogueName
              ? _c("span", [
                  _vm._v(
                    "专业课程：" + _vm._s(_vm.question.subjectCatalogueName)
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showInfo
              ? [
                  _c("span", [
                    _vm._v(
                      "使用次数：" + _vm._s(_vm.question.testPaperCount || 0)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("修改次数：" + _vm._s(_vm.question.modifyCount || 0))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("创建人：" + _vm._s(_vm.question.createUserName))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "创建时间：" +
                        _vm._s(
                          _vm._f("date")(
                            _vm.question.createTime,
                            "yyyy.MM.dd HH:mm"
                          )
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.showSimilarity
                    ? _c(
                        "span",
                        { staticClass: "inline-flex" },
                        [
                          _c("span", [_vm._v("相似题：")]),
                          _vm._v(" "),
                          _vm.question.similarityCount > 0
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: { "margin-top": "-3px" },
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.turnPage(
                                        "similarity",
                                        _vm.question
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b",
                                    { staticStyle: { color: "#F56C6C" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.question.similarityCount)
                                      )
                                    ]
                                  ),
                                  _vm._v("道")
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.question.similarityCount) + " 道"
                                )
                              ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.similarityItem.id &&
                  _vm.similarityItem.id != _vm.question.id
                    ? _c("span", [
                        _vm._v("相似度："),
                        _c("b", { staticClass: "color-red font-15" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("percent")(_vm.question.similarity, 1, 2)
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.similarityItem.id &&
                  _vm.similarityItem.id == _vm.question.id
                    ? _c("span", { attrs: { c: "" } }, [
                        _vm._v("相似度："),
                        _c("b", { staticClass: "color-blue font-15" }, [
                          _vm._v("原题")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.attestationTime
                    ? _c("span", [
                        _vm._v(
                          "认证时间：" +
                            _vm._s(
                              _vm._f("date")(
                                _vm.question.attestationTime,
                                "yyyy.MM.dd HH:mm"
                              )
                            )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.question.tenantName
                    ? _c("span", [
                        _vm._v("来源单位：" + _vm._s(_vm.question.tenantName))
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.question.questionType != 6
              ? _c("div", { staticClass: "right" }, [
                  _c(
                    "span",
                    {
                      class: { active: _vm.analysisShow },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.analysisContentShow.apply(null, arguments)
                        }
                      }
                    },
                    [_c("small", [_vm._v("解析")])]
                  )
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.analysisShow && _vm.question.questionType != 6
          ? _c("div", { staticClass: "info-body" }, [
              _c("div", {
                staticClass: "analysis content-html",
                domProps: {
                  innerHTML: _vm._s(_vm.question.questionAnswerAnalysisContent)
                }
              })
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44f3137e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f3137e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleQuestion.vue
// module id = 565
// module chunks = 14